import { Record } from 'immutable';

export const REDUCER_KEY = 'authSession';

export const AuthTokenData = new Record({
  accessToken: undefined,
  accessTokenExpired: undefined,
  refreshToken: undefined,
  refreshTokenExpired: undefined,
  scopes: undefined,

  surveyRequested: undefined,
});

export const AuthSession = new Record({
  qcsId: undefined,
  datasetId: undefined,
  datasetPlatform: undefined,
  datasetSubscriptionTier: undefined,
  datasetCreatedByClientId: undefined,

  accessToken: undefined,
  accessTokenExpired: undefined,
  refreshToken: undefined,
  refreshTokenExpired: undefined,
  scopes: undefined,

  surveyRequested: undefined,

  error: undefined,
});

export const AuthSelectDatasetPayload = new Record({
  dataset: undefined,

  reload: true,
  location: '/',
});

export type AUTH_LOGOUT_REASON = 'AUTH_LOGOUT_EXPIRED' | 'AUTH_LOGOUT_INACTIVE' | 'AUTH_LOGOUT_USER_INITIATED' | 'AUTH_LOGOUT_UNAUTHORIZED';


